import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, minRole }) {
    const { user } = useAuth();
    if (user === undefined)
        return (
            <div className="flex min-h-screen items-center justify-center bg-background">
                <div className="font-mono text-xs uppercase tracking-widest text-muted-foreground">
                    Authenticating…
                </div>
            </div>
        );
    if (user === null) return <Navigate to="/login" replace />;
    const ROLE_RANK_PR = { viewer: 1, auditor: 2, engineer: 3, admin: 4, superadmin: 5 };
    if (minRole) {
        const rank = ROLE_RANK_PR;
        if ((rank[user.role] || 0) < (rank[minRole] || 0)) {
            return (
                <div className="flex min-h-screen items-center justify-center bg-background px-6 text-center">
                    <div>
                        <div className="font-display text-3xl font-bold">403</div>
                        <div className="mt-2 text-sm text-muted-foreground">
                            You do not have permission to view this page.
                        </div>
                    </div>
                </div>
            );
        }
    }
    return children;
}
